import { RouteNames, Scopes } from 'models'

export function openFile(url: string) {
  const a = document.createElement('a')
  a.href = url
  a.target = '_blank'
  a.rel = 'noopener noreferrer'
  a.click()
  a.remove()
}

export function isEmptyString(str: string) {
  return str === null || str.trim() === ''
}

export function isInScope(variable: RouteNames, scopes: Scopes): boolean {
  return scopes.routes.includes(variable)
}

export function getRandomArrayElement(array: Array<unknown>) {
  return array[Math.floor(Math.random() * array.length)]
}

export function isNotInvalidDate(e: any) {
  return !isNaN(e?.$d.getTime())
}
